// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/modules/es7.map.of.js
// module id = 1345
// module chunks = 168707334958949